import { Button, Stack, Typography } from '@mui/material'

import {
  Maybe,
  StoreUserInfoFragment,
  User,
} from '@/clients/utoniq-core/schema'
import { ContentFrame } from '@/components/layouts/ContentFrame'
import { IonInformationModal } from '@/components/organisms/functionals'
import {
  Props as StoreUserInfoFormProps,
  StoreUserInfoForm,
} from '@/components/pages/StoreUserInfo/template/StoreUserInfoForm'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { Header } from './Header'

export type BuyNowUserInfoProps = {
  openSMSVerificationModal: boolean
  sendingVerificationLoading: boolean
  user: Maybe<StoreUserInfoFragment & Pick<User, 'formattedPhoneNumber'>>
  onUserInfoSetting: StoreUserInfoFormProps['onSubmitSetting']
  onCloseSMSVerificationModal: () => void
  onSendVerificationSMS: () => void
  onClose: () => void
}

export const BuyNowUserInfo: Organism<BuyNowUserInfoProps> = ({
  user,
  onUserInfoSetting,
  openSMSVerificationModal,
  sendingVerificationLoading,
  onCloseSMSVerificationModal,
  onSendVerificationSMS,
  onClose,
}) => {
  const { t } = useTranslation('storeUserInfo')
  return (
    <OrganismFrame>
      <Header back title={t('title', 'お客様情報の入力')} onClose={onClose} />
      <ContentFrame>
        <Stack sx={{ px: 5 }}>
          <Stack sx={{ py: 4 }}>
            <Typography variant="body2">
              {t('userInfoNote', '商品の購入に必要な情報をご入力ください。')}
            </Typography>
          </Stack>
          <StoreUserInfoForm
            onSubmitSetting={onUserInfoSetting}
            deliveryInfo={user || {}}
          />
        </Stack>
        <IonInformationModal
          open={openSMSVerificationModal}
          onClose={onCloseSMSVerificationModal}
          title={t('verifyTitle')}
          content={
            <Typography variant="body2" align="left">
              {t('verifyDesc2', { phoneNumber: user?.formattedPhoneNumber })}
            </Typography>
          }
          buttons={
            <Button
              sx={{ minWidth: 212, mt: 4 }}
              size="large"
              onClick={onSendVerificationSMS}
              loading={sendingVerificationLoading}
            >
              {t('verify')}
            </Button>
          }
          cancelText={t('close')}
        />
      </ContentFrame>
    </OrganismFrame>
  )
}
